import React, { useContext, useEffect, useRef } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useLocation } from "react-router-dom";
import { useTranslations } from "../../../../hooks/use-translations";
import { store } from "../../../Store";
import useIsMobile from "../../../../js/utilities/useIsMobile";
import { useNetworkStatus } from "../../../../hooks/use-network-status";
import { useAdvancedSearch } from "../../../../hooks/advanced-search/use-advanced-search";
import { useLanguage } from "../../../../hooks/use-language";

/**
 * Botón que permite abrir la búsqueda avanzada de libros.
 *
 * @returns {JSX.Element} SearchBooksButton
 */
export const SearchBooksButton = () => {
	const lang = useLanguage();
	const textosInterfaz = useTranslations({ section: "header", lang: lang, array: true });
	const globalState = useContext(store);
	const { state } = globalState;


	const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";

	const location = useLocation();
	const isMobile = useIsMobile();
	const networkStatus = useNetworkStatus();

	const advancedSearch = useAdvancedSearch();
	const advancedSearchButtonRef = useRef(null);
	const visible = advancedSearch?.state?.visible;

	/*Asigna el botón que abre las opciones de búsqueda */
	const assignButton = () => {
		if (advancedSearchButtonRef.current) {
			globalState.dispatch({
				type: "CHANGE",
				path: "advancedSearch.triggerButton",
				value: advancedSearchButtonRef,
			});
		}
	}

	useEffect(() => {
		assignButton();
		window.addEventListener("resize", assignButton);
		document.body.addEventListener("resize", assignButton);
		return () => {
			window.removeEventListener("resize", assignButton);
			document.body.removeEventListener("resize", assignButton);
		};
	}, [advancedSearchButtonRef]);

	return (
		<>
			{!isMobile &&
				isLogged &&
				networkStatus.online &&
				!location.pathname.includes("/visor") &&
				state.cantidadLibros !== "NULL" &&
				state.cantidadLibros > 40 && (
					<div
						ref={advancedSearchButtonRef}
						className=" ml-3 d-flex align-items-center"
					>
						<button className={`btn-libros focusable-red buttonv2 button-primary-var2 p-3 ${visible ? "activeButton" : ""}`}
							onClick={() => {
								advancedSearch.setVisible(!visible);
							}}
							aria-label="Abrir búsqueda avanzada de libros"
						>
							{textosInterfaz?.libros || "Libros"}
							<Icon icon="tabler:search" className="ml-2" />
						</button>
					</div>
				)}
		</>
	);
};
